import { render, staticRenderFns } from "./SalesQuotationList.vue?vue&type=template&id=0d5c673e&scoped=true&"
import script from "./SalesQuotationList.vue?vue&type=script&lang=js&"
export * from "./SalesQuotationList.vue?vue&type=script&lang=js&"
import style0 from "./SalesQuotationList.vue?vue&type=style&index=0&id=0d5c673e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5c673e",
  null
  
)

export default component.exports